import axios from 'axios'
import axiosRetry, { isNetworkOrIdempotentRequestError } from 'axios-retry'

import { getNewAccessToken } from './axiosQueries/auth.requests'

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_SERVER,
})

const refreshUrl = `${import.meta.env.VITE_SERVER}/api/auth/refresh-access`
let refreshPromise: any = undefined

const createRefreshPromise = () => {
  refreshPromise = new Promise((resolve, reject) => getNewAccessToken().then(resolve).catch(reject))
}

axiosRetry(axiosInstance, {
  retries: 4,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: async (e: any) => {
    const isAuthError = e.response?.status === 401 && e.config.url !== refreshUrl

    if (isAuthError) {
      let answer = false

      try {
        if (!refreshPromise) createRefreshPromise()
        await refreshPromise
        answer = true
      } catch (error: any) {
        console.log('Не удалось обновить access token', error)
      }
      refreshPromise = undefined
      return answer
    }

    return (
      isNetworkOrIdempotentRequestError(e) &&
      e.response?.status !== 500 &&
      e.response?.status !== 401
    )
  },
})

export { axiosInstance }
